/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Label } from 'reactstrap';
import { Button } from "reactstrap";
import { connect } from 'react-redux';
import {setProducts, initQuote, setCompany} from '../actions/quote'
import Brand from "./Orderspart/Brand"
import Visuals from "./Orderspart/Visuals"
import Quotes from "./Orderspart/Quotes"
import Jobs from "./Orderspart/Jobs"
import Allaccounts from "./Orderspart/Allaccounts"
import ClientHeader from './IndexSections/ClientHeader.js';

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardTitle, CardText } from 'reactstrap';
import classnames from 'classnames';
import { toast } from 'react-toastify';


function Index(props) {
  const main = useRef();
  const [activeTab, setActiveTabe] = useState('1');

  useEffect(() => {
    props.initQuote()
    props.setCompany(null)
    
  },[]);
  

  const toggle=(tab)=> {
    if (activeTab !== tab) {
      setActiveTabe(tab)
    }
  }

  const createQuote = ()=>{
      var bodyFormData = new FormData();
      axios.post(`/quotes/add`, bodyFormData).then(res => {
        const result = res.data;
        if(result.status == "success"){  
          props.history.push(`/requests/edit/${result.data.id}`)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {
        toast.error('Something was wrong. Try again');
      })
  }

  return (
    <>
      <DemoNavbar />
      <main ref={main} id="my-orders">
        <Container fluid="lg" className="m-auto">
          <Row className="mt-5 mb-5">
            <Col md="12">                           
                <Button className="btn-icon btn-2 float-right rounded-0 d-flex align-items-center" color="primary" type="button"  onClick={createQuote}>
                  <span className="btn-inner--icon mr-2 yello-icon">
                    <i className="fa fa-plus" />
                  </span>
                  NEW QUOTE REQUEST
                </Button>    
            </Col>
          </Row>
          <ClientHeader/>
          <Row className="mt-3 orders-tabs">
            <Col  md="12">
              <div>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '1' })}
                      onClick={() => { toggle('1'); }}
                    >
                      Account
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '2' })}
                      onClick={() => { toggle('2'); }}
                    >
                      Brand
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '3' })}
                      onClick={() => { toggle('3'); }}
                    >
                      Quotes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '4' })}
                      onClick={() => { toggle('4'); }}
                    >
                      Jobs
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === '5' })}
                      onClick={() => { toggle('5'); }}
                    >
                      Visuals
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1" className="">
                    <Row>
                      <Col sm="12">
                          <Allaccounts history={props.history}/>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Brand/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="3" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Quotes history={props.history}/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="4" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Jobs history={props.history}/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="5" className="">
                    <Row>
                      <Col sm="12">
                        <Card body>
                          <Visuals/>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    initQuote:()=>dispatch(initQuote()),
    setCompany:(data)=>dispatch(setCompany(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
